import SvgIcon from "../../../../parts/SvgIcon";
import ToolTip from "../../../../parts/tooltip-portal";

/**
 * A report-table column header that toggles the table's sort. Shared by
 * PlansTable and TransactionsTable so the two tabs sort identically.
 */
const SortableHeader = ({
  column,
  sortConfig,
  onSort,
  t,
  className,
  tooltip,
}) => {
  const { key, labelKey } = column;
  const nextDirection =
    sortConfig.key === key && sortConfig.direction !== "descending"
      ? "descending"
      : "ascending";
  return (
    <th className={className}>
      {/* The label itself is the tooltip trigger — an icon per header
          crowded the Plans table; the dotted underline marks it instead. */}
      {tooltip ? (
        <ToolTip body={[tooltip]} childrenContainerClass="header-explainer">
          {t(labelKey)}
        </ToolTip>
      ) : (
        t(labelKey)
      )}{" "}
      <SvgIcon
        src="/img/svg/up_down_arrows.svg"
        onClickFn={() => onSort(key, nextDirection)}
      />
    </th>
  );
};

export default SortableHeader;
